const addLinkClickListener = ({
  baseUrl,
  onClick
}) => {
  return (dom) => {
    Array.from(dom.getElementsByTagName("a")).forEach((elem) => {
      elem.addEventListener("click", (e) => {
        const target = elem;
        const href = target.getAttribute("href");
        if (!href) return;
        if (href.startsWith(baseUrl) && !elem.hasAttribute("download")) {
          e.preventDefault();
          onClick(e, href);
        }
      });
    });
    return dom;
  };
};

export { addLinkClickListener };
//# sourceMappingURL=addLinkClickListener.esm.js.map
